import lowerCase from 'lodash/lowerCase';
import upperFirst from 'lodash/upperFirst';

const upperFirstWords = ['id', 'ids'];

export const sentenceCase = string =>
  string
    ?.match(/((^[a-z]+)|([A-Z]{1}[a-z]+)|([A-Z]+(?=([A-Z][a-z])|($))))/g)
    .map(word => lowerCase(word))
    .map((word, i) =>
      i === 0 || upperFirstWords.includes(word) ? upperFirst(word) : word
    )
    .join(' ');
